import script from "./FavoritesView.vue?vue&type=script&setup=true&lang=js"
export * from "./FavoritesView.vue?vue&type=script&setup=true&lang=js"

import "./FavoritesView.vue?vue&type=style&index=0&id=e1ffcc90&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e1ffcc90"]])

export default __exports__